// extracted by mini-css-extract-plugin
module.exports = {"name":"LeaderBoard_name__3Zgl6","achievement":"LeaderBoard_achievement__3H6YA"};